<template>
  <nav class="navbar navbar-light bg-white border-bottom px-4">
    <div class="d-flex w-100 justify-content-between align-items-center">
      <div class="d-flex align-items-center gap-3">
        <button class="btn btn-light" @click="$emit('toggleSidebar')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            class="bi bi-list"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg>
        </button>
        <h2 class="mb-0 fw-bold">{{ title }}</h2>
      </div>
      <div class="d-flex align-items-center gap-3">
        <span v-if="userName" class="text-muted">{{ userName }}</span>
        <button class="btn btn-outline-danger btn-sm" @click="$emit('logout')">
          {{ $t('common.logout') }}
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AdminNavbar',
  props: {
    title: {
      type: String,
      required: true
    },
    userName: {
      type: String,
      default: ''
    }
  },
  emits: ['toggleSidebar', 'logout']
}
</script>
